function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DatasourceDsTabGeneral from './DatasourceDsTabGeneral.vue';
import DatasourceDsTabConexions from './DatasourceDsTabConexions.vue';
import DatasourceDsTabBusinessTerm from './DatasourceDsTabBusinessTerm.vue';
import DatasourceDsTabUser from './DatasourceDsTabUser.vue';
import DatasourceDsTabLineage from './DatasourceDsTabLineage.vue';
import TabColumnView from '@/components/tableau/datasource/TabColumnView';
import TabConnectionView from '@/components/tableau/datasource/TabConnectionView';
import TabBusinessTermView from '@/components/tableau/datasource/TabBusinessTermView';
import TabHistoryLogView from '@/components/tableau/TabHistoryLogView';
import { ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW, GA_EVENTS } from '@/js/constants';
import DatastudioDatasourceService from '@/apps/data-platform/services/visualization/datastudio_datasource_service';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import tasks from '@/js/tasks';
import { mapState } from 'vuex';
export default {
  name: 'FormMetaDatasourceDatastudio',
  components: {
    DatasourceDsTabGeneral: DatasourceDsTabGeneral,
    DatasourceDsTabConexions: DatasourceDsTabConexions,
    DatasourceDsTabBusinessTerm: DatasourceDsTabBusinessTerm,
    DatasourceDsTabUser: DatasourceDsTabUser,
    DatasourceDsTabLineage: DatasourceDsTabLineage,
    TabColumnView: TabColumnView,
    TabBusinessTermView: TabBusinessTermView,
    TabHistoryLogView: TabHistoryLogView,
    TabConnectionView: TabConnectionView
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
    datasetId: {
      type: String,
      default: ''
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      email_regex: new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}\.[a-z]{2,3}'),
      tab: null,
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      environ_initial: '',
      response_text: '',
      objetoInicial: null,
      valid: {
        organization: true,
        database_engine: true,
        data_operator: true,
        kdomain: true,
        ksubdomain: true,
        table: true,
        object_description: true,
        response_text: true
      },
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      tabActive: 'GENERAL',
      validform: true,
      key_lineage: 1
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    composeName: function composeName() {
      return "WORKSPACE / DATASET: ".concat(this.item.path_name, "/").concat(this.item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
    }
  }),
  mounted: function mounted() {
    var p = this.$parent;
    while (p) {
      console.log('Ancestro:', p.$options.name);
      p = p.$parent;
    }
  },
  created: function created() {
    console.log('Datasource FormMetaDatasourceDatastudio created', this.item);
    this.environ_initial = this.item['environment'];
    this.readonly = this.environ_initial == "prod";
    this.objetoInicial = JSON.parse(JSON.stringify(this.item));
    this.getDatasetById();
  },
  methods: {
    onUpdateBT: function onUpdateBT(arr) {
      console.log('arr bterms', arr);
      this.$set(this.item, 'business_terms', arr);
      console.log('this.item bterms', this.item.business_terms);
    },
    onChangeDatasource: function onChangeDatasource() {
      console.log('reaload lineage');
      this.key_lineage += 1;
    },
    onShowDataset: function onShowDataset(item) {
      this.$emit('onShowDataset', item);
    },
    showTable: function showTable(item) {
      var _this = this;
      var params = {
        project_name: item.project_name,
        dataset_name: item.dataset_name,
        object_name: item.table_name
      };
      TablesService.getTable(params).then(function (res) {
        console.log(res.data);
        if (res.data && res.success) {
          if (res.data.tables && res.data.tables.length > 0) {
            console.log(res);
            _this.$emit('onShowTable', res.data.tables[0]);
          }
        }
      });
    },
    getDatasetById: function getDatasetById() {
      var _this2 = this;
      // 1) Asegura que this.item exista
      if (!this.item) return;
      var param = {
        dataset_id: this.item.dataset_id
      };
      DatastudioDatasourceService.getDatasourceById(param).then(function (datos) {
        // 2) Fallbacks seguros si datos o datos.data son null
        var data = datos && datos.data || {};

        // 3) Usa $set para garantizar reactividad de nuevas llaves
        _this2.$set(_this2.item, 'business_terms', data.bussines_terms || []);
        _this2.$set(_this2.item, 'tables', data.tables || []);
        _this2.$delete && _this2.$delete(_this2.item, 'bussines_terms');
      }).catch(function (err) {
        console.error('[getDatasetById] error:', err);
        // Valores por defecto si falla la petición
        _this2.$set(_this2.item, 'business_terms', []);
        _this2.$set(_this2.item, 'tables', []);
      });
    },
    onCancel: function onCancel() {
      this.$emit('onCloseModal', this.item.dataset_id);
    },
    onReject: function onReject() {
      var _this3 = this;
      if (this.response_text.trim() === '') {
        this.valid_response_text = false;
        this.dangerMessage = 'Please complete Response reason';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      var data = _objectSpread(_objectSpread({
        response: this.response_text,
        domain: window.userInfo.domain
      }, this.item), {}, {
        status: 'REJECTED',
        type_flow: this.isChangeRequest
      });
      DatastudioDatasourceService.datasetSendAssignment(data).then(function (res) {
        if (res.code === 200 && res.success) {
          if (_this3.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.OWNERSHIP,
              object: 'pbi_dataset',
              domain_object: _this3.item.organization,
              operator: _this3.stringToHash(_this3.item.data_operator),
              company_code: _this3.companyCode,
              id_object: _this3.item.dataset_id,
              hash_email: _this3.stringToHash(userInfo.email),
              module: 'data_platform',
              status: 'rejected'
            });
          }
          tasks.toast.success('Solicitud rechazada correctamente.');
          _this3.onCancel();
        } else {
          tasks.toast.error(res.message);
        }
      });
    },
    onSave: function onSave() {
      var _this4 = this;
      var formElement = this.$refs.form;
      console.log('form:', formElement);
      console.log('validate:', formElement.validate());
      var form = this.$refs.form;
      var ok = form.validate();
      if (formElement.validate() === false) {
        // 1) Ver qué inputs registró el v-form y cuáles fallaron
        var fallidos = form.inputs.filter(function (i) {
          return i.hasError || i.errorBucket && i.errorBucket.length;
        });

        // 2) Log útil: nombre/label, valor y mensajes de error
        console.table(fallidos.map(function (i) {
          return {
            label: i && i.label || i && i.$attrs && i.$attrs.label || i && i.$vnode && i.$vnode.tag || i && i.$options && i.$options.name || 'input',
            value: i.internalValue,
            errors: i.errorBucket
          };
        }));

        // 3) Enfoca y desplaza al primer campo con error
        var first = fallidos[0];
        if (first) {
          var _first = fallidos[0];
          if (_first) {
            if (_first.$el && typeof _first.$el.scrollIntoView === 'function') {
              _first.$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
            if (typeof _first.focus === 'function') {
              _first.focus();
            }
          }
          _first.focus && _first.focus();
        }

        // 4) Mensaje para el usuario si quieres
        this.dangerMessage = 'Revisa los campos marcados en el formulario.';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      if (formElement.validate()) {
        if (this.isChangeRequest === ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR) {
          if (this.item.environment === ENVIRONMENT_FLOW.DEV) {
            var datasource = {
              domain: window.userInfo.domain,
              dataset: this.item
            };
            console.log('datasource to save', datasource);
            DatastudioDatasourceService.datasetAddUpdate(datasource).then(function (res) {
              if (res.code === 200) {
                if (res.success) {
                  tasks.toast.success('Dataset fields updated !');
                  // this.$toast.success('Dataset fields updated !')
                  _this4.onCancel();
                  _this4.$emit('onSave', datasource.dataset);
                } else {
                  tasks.toast.error(res.message);
                  // this.$toast.warning(res.message)
                  _this4.onCancel();
                }
              }
            });
          } else {
            this.$set(this.item, 'type_flow', 'APPROVE_OWNER');
            this.$set(this.item, 'document_id', this.item.dataset_id);
            var dataset = {
              domain: window.userInfo.domain,
              comentary: this.response_text,
              dataset: this.item
            };
            console.log('dataset to init workflow', dataset);
            DatastudioDatasourceService.datasourceInitWorkFlow(dataset).then(function (res) {
              if (res && res.code === 200) {
                if (res.success) {
                  if (res.message != 'Ok') {
                    tasks.toast.error(res.message);
                    // this.$toast.warning(res.message)
                  } else {
                    if (_this4.$gtm.enabled() && window.dataLayer) {
                      window.dataLayer.push({
                        event: GA_EVENTS.ASSIGN_OPERATOR,
                        object: 'pbi_dataset',
                        domain_object: _this4.item.organization,
                        operator: _this4.stringToHash(_this4.item.data_operator),
                        company_code: _this4.companyCode,
                        id_object: _this4.item.dataset_id,
                        hash_email: _this4.stringToHash(userInfo.email),
                        module: 'data_platform'
                      });
                    }
                    tasks.toast.success('Done. Check the ownership workflow');
                    // this.$toast.success('Check the ownership workflow')
                  }
                  _this4.onCancel();
                } else {
                  tasks.toast.error(res.message);
                  // this.$toast.warning(res.message)
                }
              }
            });
          }
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.APPROVE_OWNER) {
          var data = _objectSpread(_objectSpread({
            response_text: this.response_text,
            domain: window.userInfo.domain
          }, this.item), {}, {
            status: 'APPROVED',
            type_flow: ACCESS_TYPE_FLOW.APPROVE_OWNER
          });
          console.log('data to approve', data);
          DatastudioDatasourceService.datasetSendAssignment(data).then(function (res) {
            if (res.code === 200 && res.success) {
              tasks.toast.success('Now this dataset will available in "My Datasets"');
              if (_this4.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.OWNERSHIP,
                  object: 'pbi_dataset',
                  domain_object: _this4.item.organization,
                  operator: _this4.stringToHash(_this4.item.data_operator),
                  company_code: _this4.companyCode,
                  id_object: _this4.item.dataset_id,
                  hash_email: _this4.stringToHash(userInfo.email),
                  module: 'data_platform',
                  status: 'accepted'
                });
              }
              // this.$toast.success('Now this dataset will available in "My Datasets"')
              _this4.onCancel();
            } else {
              tasks.toast.error(res.message);
              // this.$toast.warning(res.message);
            }
          });
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
          if (JSON.stringify(this.objetoInicial) === JSON.stringify(this.item)) {
            tasks.toast.error('No change has been made to the request');
            // this.$toast.warning("No change has been made to the request")
            return;
          }
          this.$set(this.item, 'type_flow', ACCESS_TYPE_FLOW.CHANGE_METADATA);
          this.$set(this.item, 'document_id', this.item.dataset_id);
          var _dataset = {
            domain: window.userInfo.domain,
            comentary: this.response_text,
            dataset: this.item
          };
          DatastudioDatasourceService.datasourceInitWorkFlow(_dataset).then(function (res) {
            if (res && res.code === 200) {
              if (res.success) {
                tasks.toast.success('Successful request');
                // this.$toast.success('Successful request')
                if (_this4.$gtm.enabled() && window.dataLayer) {
                  window.dataLayer.push({
                    event: GA_EVENTS.CHANGE_METADATA,
                    object: 'pbi_dataset',
                    domain_object: _this4.item.organization,
                    operator: _this4.stringToHash(_this4.item.data_operator),
                    company_code: _this4.companyCode,
                    id_object: _this4.item.dataset_id,
                    hash_email: _this4.stringToHash(userInfo.email),
                    module: 'data_platform'
                  });
                }
                _this4.onCancel();
              } else {
                tasks.toast.error(res.message);
                // this.$toast.warning(res.message)
                _this4.onCancel();
              }
            }
          });
        }
      }
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onDownloadCsv: function onDownloadCsv() {
      var tplMeta = this.item;
      var columns = ['field_name', 'business_definition', 'masked', 'sensitive_data'];
      var header = ['organization', 'object_name', 'kdomain', 'ksubdomain', 'data_operator', 'environment', 'path_name', 'sensitive_data', 'object_descripcion'];
      header = header.concat(columns);
      header = header.join(';');
      var body = [];
      body.push(header);
      var data = [tplMeta.organization, tplMeta.object_name, tplMeta.kdomain, tplMeta.ksubdomain, tplMeta.data_operator, tplMeta.environment, tplMeta.path_name, tplMeta.sensitive_data ? 'true' : 'false', tplMeta.object_description];
      /*
      tplMeta.columns.forEach((item) => {
        const row = [...data]
        for (let i = 0; i < columns.length; i++) {
          row.push(item[columns[i]])
        }
        body.push(row.join(';'))
      })*/
      var row = [].concat(data);
      body.push(row.join(';'));
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var url = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + body.join('\n'));
      a.href = url;
      a.download = "Dataset-".concat(tplMeta.path_name, "_").concat(tplMeta.object_name, ".csv");
      a.click();
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.DOWNLOAD_METADATA,
          object: 'pbi_dataset',
          company_code: this.companyCode,
          id_object: tplMeta.id,
          hash_email: this.stringToHash(userInfo.email),
          module: 'data_platform'
        });
      }
      window.URL.revokeObjectURL(url);
    }
  }
};